var map = {
	"./asteroid_large_sprt.png": 6631,
	"./asteroid_med_sprt.png": 3326,
	"./asteroid_sm_sprt.png": 5506,
	"./bullet.png": 904,
	"./fire.png": 336,
	"./player_sprt.png": 6275,
	"./ufo - rick.png": 3370,
	"./ufo.png": 102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2183;